<template>
  <v-container fluid class="worker-role-form mt-3 mx-1 centered-tabs" v-show="!isFetching">
    <v-form ref="form">
      <v-row>
        <v-col cols="12">
          <h2 class="primary--text font-weight-bold pt-5 pl-2">
            {{ $t('book/admin:qrcode.form.title') }}
          </h2>

          <v-card
              elevation="0"
              flat
              tile
          >
            <v-card-text>
              <v-row justify="center">
                <v-col cols="12" md="6">

                  <!-- name, customer, code -->
                  <v-text-field
                      outlined
                      v-model="data.name"
                      clearable
                      :label="$t('common:name')"
                      :rules="[ruleRequired($t('utils:rules.required'))]"
                      tabindex="1"
                  />

                  <CustomerTypeahead
                      ref="managerTypeahead"
                      :value="data.customer"
                      @input="data.customer = $event"
                      :label="$t('common:customer')"
                      tabindex="2"
                  />

                  <v-text-field
                      outlined
                      v-model="data.code"
                      clearable
                      :label="$t('book/admin:qrcode.form.code')"
                      :rules="[ruleRequired($t('utils:rules.required'))]"
                      tabindex="3"
                  />

                  <div class="text-center">
                    <VueQrcode
                        v-if="data.code"
                        :value="getPublicURL() + '/' + data.code"
                        :scale="8"
                    />
                  </div>

                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card
              elevation="0"
              flat
              tile
          >
            <v-card-text class="pa-5 pb-4">
              <BaseButton
                  color="primary"
                  :btn-text="$t('buttons:save')"
                  @clickedButton="saveQRCode()"
              />
              <DirtyConfirmButtonDialog
                  ref="dirtyDialog"
                  :btn-text="$t('buttons:back')"
                  color="grey"
                  :dialog-title="$t('dialog:dirty-save-btn-title')"
                  :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                  :button1-text="$t('dialog:dirty-save-btn-1-text')"
                  :button2-text="$t('dialog:dirty-save-btn-2-text')"
                  @clickedButton="$router.go(-1)"
                  :dataToWatch="data"
              />

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import DirtyConfirmButtonDialog from "@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog";
import CustomerTypeahead from "@/modules/core/components/CustomerTypeAhead";
import QRCodeService from "@/modules/book/services/qrcode-service";
import QRCode from "@/modules/book/data/qrcode";
import Utils from "@/modules/core/services/utils";
import {ruleRequired} from "@/modules/core/services/rules";
import VueQrcode from "vue-qrcode";
import DataUtils from "@/modules/core/services/data-utils";
import BaseButton from "@/modules/core/components/Base/BaseButton";

export default {
  name: "QRCodeForm",
  components: {
    BaseButton,
    CustomerTypeahead,
    VueQrcode,
    DirtyConfirmButtonDialog
  },
  data() {
    return {
      data: new QRCode(),
      isFetching: true
    }
  },
  methods: {
    ruleRequired,
    saveQRCode() {
      if (!this.$refs.form.validate()) {
        // TODO scroll to specific form field which doesnt require the rules
        window.scrollTo(0, 0);
        return;
      }

      QRCodeService.putToAPI(this.data,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('book/admin:qrcode.form.snackbar')}));
          this.$router.go(-1);
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('book/admin:qrcode.form.snackbar')}))
        }
      )
    },
    getPublicURL(){
      return QRCodeService.getPublicURL();
    }
  },
  created() {
    QRCodeService.readFromAPI(this.$route.params.id,
      (resp) => {
        this.data = DataUtils.parseDataToSingleObject(resp.data, QRCode);
        if(this.data.customer) {
          this.$refs.managerTypeahead.initialise(this.data.customer);
        }
        this.isFetching = false;
        this.$refs.dirtyDialog.startWatch();
      },
      (error) => {
        this.$logger.error("Failed receiving QRCode, because: " + error);
        this.$router.push('/404')
      }
    )
  }
}
</script>
